export default __webpack_public_path__ + "07ab63f06b5c30614d88f797f23702b6.png";